import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  FileManagerAccessDenied,
  FileManagerLoadingState,
} from '@/components/FileManager';
import { useFileManagerAuth } from '@/hooks/useFileManagerAuth';

interface FileManagerRouteProtectionProps {
  children: React.ReactNode;
}

/**
 * Route protection component for File Manager functionality.
 * Ensures only users with FileManagerAdmin role can access file manager routes.
 *
 * @param children - The protected component to render if authorized
 * @returns Protected component or access denied/redirect
 */
const FileManagerRouteProtection: React.FC<FileManagerRouteProtectionProps> = ({
  children,
}) => {
  const { isAuthenticated, isAuthorized, isLoading } = useFileManagerAuth();

  // Show loading state while authentication is being checked
  if (isLoading) {
    return <FileManagerLoadingState message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!isAuthorized) {
    return <FileManagerAccessDenied />;
  }

  return <>{children}</>;
};

export default FileManagerRouteProtection;
